<template>
    <div class="load_page__container">
        <div class="load_page__wrapper">
            <div class="load_page__logo">
                <img src="/images/getorder_logo.svg">
            </div>
            <div class="load_page__progress">
                <progress_bar/>
            </div>
        </div>
    </div>
</template>

<script>
import progress_bar from "./ProgressBar.vue";
export default {
    name: "loader_page",
    components: {
        progress_bar
    },
}
</script>
